import { getToken } from '@/js/helper/token.ts'

declare global {
    interface Window {
        endpointURL: string
    }
}

export const useApi = () => {
    const apiEndpoint = (): string => {
        return window.endpointURL ?? import.meta.env.VITE_APP_URL
    }

    const callEndpoint = async (path: string, options?: RequestInit): Promise<Response> => {
        const csrfToken = getToken('html')

        return await fetch(apiEndpoint() + path, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-CSRF-TOKEN': csrfToken,
            },
            ...options,
        })
    }

    return { callEndpoint, apiEndpoint }
}
